module.exports = __webpack_public_path__ + "static/media/insta.dd4b8d32.jpg";